(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".product-recommendations").innerHTML;
      theme.ProductBlockManager.loadImages(productRecommendationsSection);
      theme.initAnimateOnScroll();
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["productos-recomendados"] && !Shopify.designMode) return;
  try {
    
(function () {

  function buildSrcsetFromTemplate(tpl, widths) {
    if (!tpl || tpl.indexOf('{width}') === -1) return '';
    return widths.map(function(w){
      return tpl.replace('{width}', w) + ' ' + w + 'w';
    }).join(', ');
  }

  function parseWidths(str) {
    try {
      // data-widths viene como "[180, 220, ...]"
      var arr = JSON.parse(str);
      return Array.isArray(arr) ? arr : [];
    } catch (e) {
      return [];
    }
  }

  function hydrateManualRimages(scope) {
    if (!scope) scope = document;

    var imgs = scope.querySelectorAll('img.rimage__image.lazyload--manual');
    if (!imgs.length) return;

    imgs.forEach(function(img){
      // Si ya tiene src/srcset, no tocar
      if (img.getAttribute('src') || img.getAttribute('srcset') || img.getAttribute('data-srcset')) return;

      var tpl = img.getAttribute('data-src') || '';
      var widths = parseWidths(img.getAttribute('data-widths') || '[]');

      // 1) Si podemos construir srcset, lo hacemos
      if (tpl && widths.length) {
        var srcset = buildSrcsetFromTemplate(tpl, widths);
        if (srcset) {
          img.setAttribute('data-srcset', srcset);
          img.setAttribute('srcset', srcset);
          // deja data-sizes="auto" como ya lo tienes
        }
      }

      // 2) Convertir de "manual" a "lazyload estándar"
      img.classList.remove('lazyload--manual');
      img.classList.add('lazyload', 'lazyautosizes');

      // 3) Fallback: si por alguna razón no hay srcset, al menos setear un src usable
      if (!img.getAttribute('src')) {
        if (tpl && tpl.indexOf('{width}') !== -1) {
          img.setAttribute('src', tpl.replace('{width}', 720));
        } else if (tpl) {
          img.setAttribute('src', tpl);
        }
      }
    });

    // 4) Forzar a que el lazy loader re-scan
    if (window.lazySizes && lazySizes.loader && typeof lazySizes.loader.checkElems === 'function') {
      lazySizes.loader.checkElems();
    }
  }

  function reinitAfterAjax(scope) {
    hydrateManualRimages(scope);

    // Si el tema tiene inicializador de carruseles, correrlo
    if (window.theme && typeof theme.initCarousels === 'function') {
      theme.initCarousels();
    }

    // Carga de imágenes del tema (si existe)
    if (window.theme && theme.ProductBlockManager && typeof theme.ProductBlockManager.loadImages === 'function') {
      theme.ProductBlockManager.loadImages(scope);
    }

    if (window.theme && typeof theme.initAnimateOnScroll === 'function') {
      theme.initAnimateOnScroll();
    }
  }

  function loadProductRecommendationsInto(el) {
    if (!el || !el.dataset || !el.dataset.url) return;

    var request = new XMLHttpRequest();
    request.open("GET", el.dataset.url);
    request.onload = function() {
      if (request.status >= 200 && request.status < 300) {
        var container = document.createElement("div");
        container.innerHTML = request.response;

        var incoming = container.querySelector(".productos-recomendados");
        if (!incoming) return;

        el.innerHTML = incoming.innerHTML;
        reinitAfterAjax(el);
      }
    };
    request.send();
  }

  function initAll(root) {
    (root || document).querySelectorAll(".productos-recomendados[data-url]").forEach(loadProductRecommendationsInto);
  }

  document.addEventListener("DOMContentLoaded", function() {
    initAll(document);
  });

  // Theme editor re-render
  document.addEventListener("shopify:section:load", function(event) {
    var sectionContainer = document.getElementById("shopify-section-" + event.detail.sectionId);
    if (sectionContainer) initAll(sectionContainer);
  });

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products-carousel"] && !Shopify.designMode) return;
  try {
    
var loadRelatedProductsClassic = function() {
  var wrapper = document.querySelector(".related-products-wrapper");
  if (wrapper === null) { return; }

  // Evitar doble carga si ya tiene contenido
  if (wrapper.querySelector('.product-list')) { return; }

  var request = new XMLHttpRequest();
  request.open("GET", wrapper.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      
      // Insertar el contenido interior solamente
      var newContent = container.querySelector(".related-products-wrapper");
      if (newContent && newContent.innerHTML.trim().length > 0) {
        wrapper.innerHTML = newContent.innerHTML;
        
        // RE-INICIALIZAR JAVASCRIPT DEL TEMA
        // Disparamos el evento para que theme.js detecte la "nueva" sección
        // Al tener data-section-type="featured-collection" en el wrapper, ahora sí debería funcionar.
        var sectionId = wrapper.dataset.sectionId;
        
        // Pequeño delay para asegurar que el DOM está listo
        setTimeout(function(){
            var event = new CustomEvent('shopify:section:load', {
                detail: { sectionId: sectionId }
            });
            document.dispatchEvent(event);
            
            // Fallback: Forzar evento resize para despertar a Slick Slider si falla el evento anterior
            window.dispatchEvent(new Event('resize'));
        }, 100);
      }
    }
  };
  request.send();
};

document.addEventListener("shopify:section:load", function(event) {
  // Solo recargar si es nuestra sección específica
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products-wrapper')) {
     // En el editor, recargamos la llamada AJAX
     loadRelatedProductsClassic();
  }
});

// Ejecutar en carga inicial
loadRelatedProductsClassic();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"] && !Shopify.designMode) return;
  try {
    
(function() {
  function loadProductRecommendationsIntoSection() {
    var section = document.querySelector('.related-products-legacy');
    if (!section) return;

    var url = section.dataset.url;
    if (!url) return;

    var request = new XMLHttpRequest();
    request.open('GET', url);
    request.onload = function() {
      if (request.status >= 200 && request.status < 300) {
        var temp = document.createElement('div');
        temp.innerHTML = request.response;

        var incoming = temp.querySelector('.related-products-legacy');
        if (!incoming) return;

        // Reemplaza solo el inner para mantener data-url y dataset intactos
        section.innerHTML = incoming.innerHTML;

        // Inicializa navegación prev/next (fallback sencillo)
        initSimpleCarousel(section);
      }
    };
    request.send();
  }

  function initSimpleCarousel(root) {
    try {
      var container = root.querySelector('.product-list.carousel');
      var prevBtn = root.querySelector('.collection-slider .prev');
      var nextBtn = root.querySelector('.collection-slider .next');

      if (!container || (!prevBtn && !nextBtn)) return;

      var itemWidth = function() {
        var first = container.querySelector('.product-block, .product-list__item');
        // Si no hay item, usa ancho del contenedor
        return first ? first.getBoundingClientRect().width : container.getBoundingClientRect().width * 0.8;
      };

      var scrollBy = function(dir) {
        var delta = itemWidth();
        container.scrollBy({ left: dir * delta, behavior: 'smooth' });
      };

      if (prevBtn) {
        prevBtn.addEventListener('click', function(e) {
          e.preventDefault();
          scrollBy(-1);
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', function(e) {
          e.preventDefault();
          scrollBy(1);
        });
      }

      // Evita conflictos con swipe interno: lo desactivamos si el carrusel externo está activo
      // (ya se hizo con no_swiping: section.settings.enable_carousel)
      // Además, prevenimos que el contenedor capture gestos verticales y permita el horizontal.
      container.style.scrollSnapType = 'x proximity';
      container.style.overflowX = 'auto';
      container.style.webkitOverflowScrolling = 'touch';
    } catch (err) {
      // Silencioso: en caso de que el tema ya maneje la navegación, no interferimos.
    }
  }

  // Editor: recarga al cargar/editar la sección
  document.addEventListener('shopify:section:load', function(event) {
    if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products-legacy')) {
      loadProductRecommendationsIntoSection();
    }
  });

  // Carga inicial
  loadProductRecommendationsIntoSection();
})();

  } catch(e) { console.error(e); }
})();
})();
